// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24XCH","placeholdersHeader":"styles_placeholdersHeader__1-jNU","editorStyle":"styles_editorStyle__2T92A","placeholdersBox":"styles_placeholdersBox__LGLcQ"};